export interface ErrorContainerPrimitiveProps {
  status?: string
}

export interface ErrorContainerComplexProps {}

export interface ErrorContainerEventProps {
  handleBackToReview?(): void
}

export enum ErrorStatus {
  SERVER = 'server',
  OLD = 'old',
  ALREADY_REVIEWED = 'alreadyReviewed',
}

export type Props = ErrorContainerPrimitiveProps &
  ErrorContainerComplexProps &
  ErrorContainerEventProps
